import React, { useState, useEffect } from 'react';
import './Slideshow.css';

const Slideshow = () => {
  // Get all slideshow images dynamically
  const slideshowImages = [
    '/assets/slideshow/slideshow1.png',
    '/assets/slideshow/slideshow2.png',
    '/assets/slideshow/slideshow3.png',
    '/assets/slideshow/slideshow4.png'
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => 
        prevSlide === slideshowImages.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [slideshowImages.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideshowImages.length - 1 : currentSlide - 1);
  };

  const goToNextSlide = () => {
    setCurrentSlide(currentSlide === slideshowImages.length - 1 ? 0 : currentSlide + 1);
  };

  return (
    <div className="slideshow-container">
      <div className="slideshow">
        {slideshowImages.map((image, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img src={image} alt={`Slide ${index + 1}`} />
          </div>
        ))}
        
        {/* Navigation arrows */}
        <button className="slide-nav prev" onClick={goToPrevSlide} aria-label="Previous slide">
          &#8249;
        </button>
        <button className="slide-nav next" onClick={goToNextSlide} aria-label="Next slide">
          &#8250;
        </button>
      </div>
      
      {/* Slide indicators */}
      <div className="slide-indicators">
        {slideshowImages.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Slideshow;
